import { Crumbs } from "molecules/Breadcrumbs";
import { TitleHeading } from "molecules/TitleHeading";
import React, { useState } from "react";
import { SmallHadding } from "molecules/SmallHeadding";
import { DetailBox } from "molecules/DetailBox";
import { ArrowButton } from "molecules/ArrowButton";
import ItemSlider from "./itemSlider";
import styled from "styled-components";
import { MultiSelect } from "primereact/multiselect";
import DropdownTable from "component/DropdownTable/DropdownTable";
import { MidTitle } from "molecules/MidTitle";
import { Paginator } from "primereact/paginator";
import { useNavigate } from "react-router-dom";
import { SectionBorder } from "molecules/SectionBorder";
import Modal from "react-modal";
import { useSelector, RootStateOrAny } from "react-redux";
import TruncatedText from "component/TruncatedText/TruncatedText";

const CustDropdown = styled(MultiSelect)`
  border: 1px solid rgb(200, 32, 39);
  background: transparent;
  border-radius: 0;
  font-weight: 500;
`;

const CustPaginator = styled(Paginator)`
  .p-paginator-first:not(.p-disabled):not(.p-highlight):hover,
  .p-paginator-prev:not(.p-disabled):not(.p-highlight):hover,
  .p-paginator-next:not(.p-disabled):not(.p-highlight):hover,
  .p-paginator-last:not(.p-disabled):not(.p-highlight):hover {
    color: #000;
  }

  .p-paginator-pages {
    margin: 0 1rem;
  }

  .p-paginator-pages .p-paginator-page.p-highlight {
    background: #010101;
    border-color: #010101;
    color: #fff;
    cursor: default;
  }

  .p-paginator-pages .p-paginator-page {
    border: none;
    border-radius: 50% !important;
    color: #010101;
    float: left;
    font-size: 18px;
    font-weight: 500;
    height: 2pc;
    line-height: 2pc;
    min-width: 2pc;
    padding: 0 !important;
    text-align: center;
    text-decoration: none;
  }

  .p-paginator-pages .p-paginator-page:hover {
    background: #010101;
    color: #fff;
    text-decoration: none;
  }
`;

const inshightdata = [
  {
    title: "Lorem Ipsum is simply dummy text of the printing and...",
    subtitle: "Case Study",
    description:
      "Quantum is driven by its Vision statement: “To elevate the professional standards of the Indian realty sector by creating projects that deliver the best value and experience” Quantum imb...",
    image: "media/home_slider/blog-1-400x248 1.png",
    navigate: "/insights-details",
  },
  {
    title: "Lorem Ipsum is simply dummy text of the printing and...",
    subtitle: "Case Study",
    description:
      "Quantum is driven by its Vision statement: “To elevate the professional standards of the Indian realty sector by creating projects that deliver the best value and experience” Quantum imb...",
    image: "media/home_slider/blog-1-400x248 1 (1).png",
    navigate: "/insights-details-new",
  },
  {
    title: "Lorem Ipsum is simply dummy text of the printing and...",
    subtitle: "Case Study",
    description:
      "Quantum is driven by its Vision statement: “To elevate the professional standards of the Indian realty sector by creating projects that deliver the best value and experience” Quantum imb...",
    image: "media/home_slider/blog-1-400x248 1.png",
    navigate: "/insights-details",
  },
  {
    title: "Lorem Ipsum is simply dummy text of the printing and...",
    subtitle: "Case Study",
    description:
      "Quantum is driven by its Vision statement: “To elevate the professional standards of the Indian realty sector by creating projects that deliver the best value and experience” Quantum imb...",
    image: "media/home_slider/blog-1-400x248 1 (2).png",
    navigate: "/insights-details-new",
  },
  {
    title: "Lorem Ipsum is simply dummy text of the printing and...",
    subtitle: "Case Study",
    description:
      "Quantum is driven by its Vision statement: “To elevate the professional standards of the Indian realty sector by creating projects that deliver the best value and experience” Quantum imb...",
    image: "media/home_slider/blog-1-400x248 1 (1).png",
    navigate: "/insights-details",
  },
  {
    title: "Lorem Ipsum is simply dummy text of the printing and...",
    subtitle: "Case Study",
    description:
      "Quantum is driven by its Vision statement: “To elevate the professional standards of the Indian realty sector by creating projects that deliver the best value and experience” Quantum imb...",
    image: "media/home_slider/blog-1-400x248 1.png",
    navigate: "/insights-details-new",
  },
];
export const Insights = () => {
  const {
    data: blogsData,
    loading: loadingBlogs,
    error: errorBlogs,
  } = useSelector((state) => state.blogs);

  // console.log(blogsData)
  const [selectedStrategies, setSelectedStrategies] = useState(null);
  const strategies = [
    { name: "Real Assets", code: "RA" },
    { name: "Retirement Solutions", code: "RS" },
    { name: "Equity", code: "EQ" },
    { name: "Credit", code: "CR" },
    { name: "Financial Services", code: "FS" },
    { name: "Secondaries", code: "SE" },
  ];
  const Categories = [
    { name: "Investors", code: "RA" },
    { name: "Developers", code: "RS" },
    { name: "Equity", code: "EQ" },
    { name: "Research", code: "CR" },
  ];

  const Topics = [
    { name: "Quantum Updates", code: "RA" },
    { name: "Case Study", code: "RS" },
    { name: "Life at Quantum", code: "EQ" },
    { name: "Insights", code: "CR" },
  ];
  const Formats = [
    { name: "PDF", code: "RA" },
    { name: "Video", code: "RS" },
    { name: "Article", code: "EQ" },
  ];
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(9); // Set to
  const totalPages = Math.ceil(10 / rows); // Calculate total pages

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const openModal = () => {
    setModalIsOpen(true);
  };
  const customStylesForMobile = {
    content: {
      position: "absolute",
      top: 150,
      right: 0, // right: "100%",
      // right: "auto",
      bottom: 0,
      paddingTop: 0,
      marginTop: 0,
      // transform: "translate(-50%, -50%)",
      width: "100%",
      maxWidth: "250px",
      maxHeight: "100vh",
      overflowY: "auto",
      border: "none !importent", // Remove the default border

      // backgroundColor: 'red'

      // backgroundColor: 'red'
    },
  };

  const customStyles = {
    content: {
      top: "50%", // Center it vertically
      right: "0", // Align to the right
      left: "auto", // Remove any left offset
      bottom: "0", // Make it stretch to the bottom if needed
      transform: "translateY(-50%)", // Center it vertically
      width: "40%", // Adjust the width, you can change this percentage based on your needs
      maxWidth: "1000px", // Ensures that it doesn’t go over a certain width
      height: "100vh", // Full height
      padding: "20px", // Adjust padding if necessary
      backgroundColor: "#fff", // Ensure it has a proper background color
      overflowY: "auto", // Allow scrolling if content overflows
      zIndex: 999, // Ensure it’s always on top
    },
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const navigate = useNavigate();

  const handleNavigate = (link) => {
    navigate(link);
  };

  return (
    <div className="backgroundThm mobileContainer">
      <section>
        <div className="container  pl-0 pr-0">
          <Crumbs />
          <div className="grid section-title ">
            <div
              className="lg:col-4 md:col-3 sm:col-12 pl-0 "
              data-aos="fade-up"
            >
              {/* <SmallHadding text="Insights" className="mt-0 mb-3" /> */}
              <h1
                className="pageTitle"
                style={{
                  fontSize: "76px",
                  fontFamily: "EB Garamond",
                  marginBottom: "15px",
                }}
              >
                Insights
              </h1>
            </div>
          </div>
          <div className="mb-5 border-top-1  pt-3 border-black-600 flex">
            <div style={{ backgroundColor: "#4E6766" }} className="w-full">
              <div className="grid  p-5 align-items-center">
                <div
                  className="lg:col-5 md:col-6 sm:col-12 text-white"
                  data-aos="fade-up"
                >
                  <SmallHadding
                    text="Investment Insights"
                    className="mb-4 text-5xl eb-garamond-font"
                  />
                </div>
                <div className="lg:col-7 md:col-6 sm:col-12 lg:p-2 md:p-4 sm:p-1">
                  <div className="flex align-items-center text-base mb-4 ">
                    <DetailBox
                      details=" Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the Ind..."
                      className="text-white fs-30"
                    />
                  </div>
                  <ArrowButton
                    width="170"
                    buttonText="Read more"
                    arrowColor="#000"
                    bgColor="#CDC08B"
                    textColor="#FFF"
                    url="/"
                    className="ml-0"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container pl-0 pr-0  mb-4">
          <SectionBorder />
          <div
            className="flex align-items-center my-2 pl-0 showInMobile"
            style={{
              // borderBottom: "2px solid rgb(200, 32, 39)",
              width: "100px",
              paddingLeft: "1rem",
            }}
          >
            <div className="showInMobile">
              <i className="pi pi-sliders-h mr-2 "></i>
            </div>
            <span className="text-lg s-25 showInMobile" onClick={openModal}>
              Filter
            </span>
          </div>
          <div className=" showInMobile">
            <SectionBorder />
          </div>
        </div>
      </section>

      <section className="section-padding px-0 pt-0 ">
        <div className="container  pl-0 pr-0">
          <div
            className="px-0 "
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div className="lg:col-3 md:col-6 sm:col-12 hideInMobile pl-0 ">
              <div
                className="flex align-items-center  "
                style={{
                  borderBottom: "2px solid rgb(200, 32, 39)",
                  width: "100px",
                  paddingLeft: "1rem",
                }}
              >
                <i className="pi pi-sliders-h mr-2 "></i>
                <span className="text-lg s-25 ">Filter</span>
              </div>
            </div>
            <div className=" pr-0 insightDropdown" style={{}}>
              <DropdownTable title="Select a Categories" options={Categories} />
              <DropdownTable title="Select a Formats" options={Formats} />

              <DropdownTable title="Select a Topics" options={Topics} />
            </div>
          </div>

          {/* <SectionBorder/> */}

          <div className="grid mt-4">
            {/* <div style={{width:'100%',alignSelf:'flex-end',display:'flex',justifyContent:'flex-end',alignItems:'flex-end',marginBottom:'-25px'}}>
              <h2 style={{fontSize:18, fontFamily:'Avenir',marginRight:'5%'}}>1 of the 9</h2>
              </div> */}
            <div className="grid  -mr-2 mt-1">
              {/* <ItemSlider /> */}
              {blogsData?.map((item, index) => (
                <div
                  className="lg:col-4 md:col-6 sm:col-12 mb-0 insightDiv pl-0 "
                  data-aos="fade-up"
                  key={index}
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate(`/insights-details/${item?.id}`)}
                >
                  <div className="image-container mb-1">
                    <img
                      // src={item.image}
                      src={`${
                        item?.image
                          ? "" + item?.image
                          : "media/home_slider/blog-1-400x248 1.png"
                      }`}
                      alt={item.title}
                      className="zoom-image w-full"
                      style={{ marginBottom: "10px" }}
                      // onMouseEnter={() => setHoveredIndex(index)}
                      // onMouseLeave={() => setHoveredIndex(null)}
                    />
                  </div>
                  {/* <SmallHadding text={item.title} className="mb-2" /> */}
                  <h3
                    //  className={hoveredIndex === index ? 'underline' : ''}
                    className="underlineText"
                    style={{ fontSize: "19px" }}
                  >
                    {item.title}
                  </h3>
                  <MidTitle text={item.sub_title} className="my-1" />
                  <DetailBox
                    details={<TruncatedText text={item.description} />}
                    style={{ fontSize: "1pc !important" }}
                  />

                  {/* <div className="border-bottom-1 border-black-400"></div> */}
                </div>
              ))}
              <div
                className="lg:col-12 md:col-12 sm:col-12 -mb-3 w-100 -mt-1 p-0"
                style={{
                  display: "flex",
                  alignItems: "flex-end",
                  justifyContent: "flex-end",
                }}
              >
                <CustPaginator
                  first={first}
                  rows={rows}
                  totalRecords={2}
                  rowsPerPageOptions={[9]} // Pagination set for 9 items per page
                  // onPageChange={onPageChange} // Handle page change and call scroll
                  prevPageLinkIcon={
                    <i
                      className="pi pi-arrow-circle-left"
                      style={{ fontSize: "2rem" }}
                    ></i>
                  }
                  nextPageLinkIcon={
                    <i
                      className="pi pi-arrow-circle-right"
                      style={{ fontSize: "2rem" }}
                    ></i>
                  }
                  currentPageReportTemplate="{currentPage} of {totalPages}"
                  template={{
                    layout: "PrevPageLink CurrentPageReport NextPageLink",
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          style={customStylesForMobile}
          contentLabel="Project Detail Modal"
          className=" mobileHistoryDiv"
        >
          <div className="col-12 ">
            <div
              className="before-red-border1 "
              style={{
                position: "relative",
                top: "100px",
                zIndex: "9",
                display: "flex",
                flexDirection: "column",
                gap: "20px",
                width: "100%",
              }}
            >
              <div className="">
                <SectionBorder />
                <div
                  className="flex align-items-center py-0  my-2"
                  style={{
                    // borderBottom: "2px solid rgb(200, 32, 39)",
                    width: "100px",
                    paddingLeft: "1rem",
                  }}
                >
                  <i className="pi pi-sliders-h mr-2 "></i>
                  <span className="text-lg s-25" onClick={openModal}>
                    Filter
                  </span>
                </div>
                <SectionBorder />
              </div>

              <DropdownTable title="Select a Categories" options={Categories} />
              <DropdownTable title="Select a Formats" options={Formats} />

              <DropdownTable title="Select a Topics" options={Topics} />
            </div>
          </div>
        </Modal>
      </section>
    </div>
  );
};
